<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="md" :visible="modal.show" :data="model" scrollable
                   :title="model.uuid ? $t(`Update Relation`) : $t(`Create New Relation`)" @show="onShow"
                   @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')" :is-loading="loading" modal-class="mobile-full-screen">
      <div class="row">
        <div class="col-md-6">
          <customer-select-input-widget :model="model" attribute="related_customer_uuid"/>
        </div>
        <div class="col-md-6">
          <input-widget :items="customerRelationTypes" value-field="value" display-field="${item.label}" type="select2"
                        :model="model" attribute="type"/>
        </div>
        <div class="col-md-6" v-if="model.type === 'Other (free text)'">
          <input-widget v-if="model.type === 'Other (free text)'"
                        :model="model" type="text" attribute="type_text"/>
        </div>
        <div class="col-md-12" v-if="model.type === 'intermediary'">
          <input-widget :model="model"
                        attribute="intermediary_commission_from"
                        value-field="value"
                        multiple
                        :options="{multiple: true}"
                        display-field="${item.key}"
                        type="select2"
                        :rules="!model.intermediary_flat_price || model.intermediary_commission_rate ? 'required' : ''"
                        :items="intermediaryCommissionFromData"/>
        </div>
        <div class="col-md-6" v-if="model.type === 'beneficiary'">
          <percentage-input-widget :model="model" attribute="beneficiary_rate"/>
        </div>
        <div class="col-md-6" v-if="model.type === 'intermediary'">
          <percentage-input-widget :model="model" attribute="intermediary_commission_rate"/>
        </div>
        <div class="col-md-6" v-if="model.type === 'intermediary'">
          <input-widget type="number" :model="model" attribute="intermediary_flat_price"/>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4" v-if="model.type === 'intermediary'">
          <input-widget type="checkbox" :model="model" attribute="including_vat" is-switch/>
        </div>
        <div class="col-md-4" v-if="model.type === 'intermediary'">
          <input-widget type="checkbox" :model="model" attribute="taxable" is-switch/>
        </div>
        <template v-if="isHideByRelationType()">
          <div class="col-md-4">
            <input-widget type="checkbox" is-switch attribute="confirmations" :model="model"/>
          </div>
          <div class="col-md-4">
            <input-widget type="checkbox" is-switch attribute="suggestions" :model="model"/>
          </div>
          <div class="col-md-4">
            <input-widget type="checkbox" is-switch attribute="settlements" :model="model"/>
          </div>
          <div class="col-md-4">
            <input-widget type="checkbox" is-switch attribute="cc" :model="model"/>
          </div>
        </template>
      </div>

      <div class="row">
        <div class="col-md-12">
          <input-widget :model="model" attribute="note" type="textarea"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "../../core/components/artisio-modal/ArtisioModal";
  import NewRelationModel from "@/modules/relations/NewRelation.model";
  import CustomerSelectInputWidget from "@/core/widgets/CustomerSelectInputWidget";
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import PercentageInputWidget from "@/core/widgets/PercentageInputWidget";
  import RelationsService from "@/modules/relations/RelationsService";
  import i18n from "@/shared/i18n";

  const {mapState, mapActions} = createNamespacedHelpers('relations');
  const {mapState: mapStateGlobal} = createNamespacedHelpers('global');

  export default {
    name: "NewRelationModal",
    components: {
      InputWidget,
      CustomerSelectInputWidget,
      ArtisioModal,
      PercentageInputWidget
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new NewRelationModel(),
        errorMessage: null,
        intermediaryCommissionFromData: [
          {key: i18n.t('Hammer Price'), value: 'hammer_price'},
          {key: i18n.t('Premium'), value: 'premium'},
          {key: i18n.t('Commission'), value: 'commission'},
        ]
      }
    },
    computed: {
      ...mapState({
        modal: state => state.modal,
        editObject: state => state.modal.object
      }),
      ...mapStateGlobal({
        customerRelationTypes: state => {
          return [
            ...state.customerRelationTypes,
            ...[{'label': 'Other (free text)', 'value': 'Other (free text)'}]
          ]
        }
      }),
    },
    watch: {
      editObject() {
        if (this.editObject && this.editObject.uuid) {

          let tmpLinkObj = this.editObject;

          if (tmpLinkObj.type &&
            tmpLinkObj.type !== '' &&
            !this.customerRelationTypes.find(a => a.value === tmpLinkObj.type)) {

            tmpLinkObj.type_text = tmpLinkObj.type;
            tmpLinkObj.type = 'Other (free text)';
          }
          this.model = new NewRelationModel(tmpLinkObj);
        }
      },
      'model.type': 'checkAndResetRelations',
    },
    methods: {
      ...mapActions(['hideModal', 'getTableData']),
      onShow() {
        this.showConfirmation = true
      },
      onHidden() {
        this.model = new NewRelationModel();
        this.hideModal();
      },
      async onSubmit() {
        this.loading = true;
        let response;

        let params = this.model.toJSON()
        params.object_uuid = this.modal.sourceObject.uuid
        if (params.type === 'Other (free text)') {
          params.type = params.type_text;
        }
        if (this.model.uuid) {
          response = await RelationsService.updateRelation(params.uuid, params)
        } else {
          response = await RelationsService.createRelation(params)
        }
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.getTableData()
          this.hideModal()
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0])
          } else {
            let tmpBody = response.body
            if (this.model.type_text && tmpBody.type) {
              tmpBody.type_text = tmpBody.type
              delete tmpBody.type
            }
            this.model.setMultipleErrors(tmpBody);
          }
        }
      },
      isHideByRelationType() {
        return ['intermediary', 'contact_person', 'notary', 'person_of_interest'].includes(this.model.type)
      },
      checkAndResetRelations() {
        if (!this.isHideByRelationType()) {
          this.model.confirmations = false;
          this.model.settlements = false;
          this.model.suggestions = false;
          this.model.cc = false;
        }
      },
    }
  }
</script>

<style scoped>

</style>
